import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { actions as reportSagaActions } from "../redux/reportsSaga";
import { rtReducerActions } from "../../ReceiptTracking"
import { rtSagaActions } from "../../ReceiptTracking";

import { ReportSearchForm } from "./ReportSearchForm";

import { Button, Spinner, Alert, Fade } from "react-bootstrap";
import DataTable from "react-data-table-component";
import "jspdf-autotable";
import { format } from "date-fns";

const moneyFormater = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "PGK"
});

const XLSX = require('xlsx');

const date = Date().split(" ");
const dateStr = date[2] + date[1] + date[3];

const presentDate = new Date();
const formatPresentDate = format(presentDate, "dd/MM/yyyy");

// Blatant "inspiration" from https://codepen.io/Jacqueline34/pen/pyVoWr
function convertArrayOfObjectsToCSV(array) {
  let result;

  const columnDelimiter = ",";
  const lineDelimiter = "\n";
  let keys = Object.keys(array[0]);

  keys = keys.map((k) => {
    let key = {};
    key.value = k;
    key.name = k.replaceAll("_", " ");
    key.name = key.name.split(' ').map(str => (
      str.charAt(0).toUpperCase() + str.slice(1)
    )).join(' ');
    
    return key;
  })
  
  result = "";
  result += keys.map(k => k.name).join(columnDelimiter);
  result += lineDelimiter;
  
  array.forEach((item) => {
    
    let ctr = 0;
    keys.forEach((key) => {
      if (ctr > 0) result += columnDelimiter;

      result += item[key.value];

      ctr++;
    });
    result += lineDelimiter;
  });
  
  return result;
};

// Blatant "inspiration" from https://codepen.io/Jacqueline34/pen/pyVoWr
function downloadCSV(array, reportTitle) {

  // error handler
  if ( reportTitle === "" || reportTitle === null || reportTitle === undefined) {
    alert("Please generate a valid report before trying the download option!");
    return;
  }

  if(array.length === 0){
    return
  }
  const link = document.createElement("a");
  let csv = convertArrayOfObjectsToCSV(array);
  if (csv == null) return;

  const filename = `${reportTitle} Report_${dateStr}.csv`;

  if (!csv.match(/^data:text\/csv/i)) {
    csv = `data:text/csv;charset=utf-8,${csv}`;
  }

  link.setAttribute("href", encodeURI(csv));
  link.setAttribute("download", filename);
  link.click();
};

function downloadEXCEL(array, reportTitle) {

  if ( reportTitle === "" || reportTitle === null || reportTitle === undefined) {
    alert("Please generate a valid report before trying the download option!");
    return;
  }

  if(array && array.length === 0){
    return
  }

  let worksheet = XLSX.utils.json_to_sheet(array);
  var workBook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workBook, worksheet, reportTitle);

  XLSX.writeFile(workBook, `${reportTitle} Report_${dateStr}.xlsx`);
  
};

function downloadPDFReport(dataStr, reportName){
  if(!dataStr){
    alert("PDF Report was not generated.");
    return
  }
  if (dataStr.length === 0){
    alert("PDF Report was not generated.");
    return;
  }
  const filename = `${reportName} Report_${dateStr}.pdf`;
  const link = document.createElement("a");
  let data = 'data:application/pdf;base64,' + dataStr;
  link.setAttribute("href", data);
  link.setAttribute("download", filename);
  link.click();
};

const Export = ({ onCSVExport, onPDFExport, onXLSXExport, pdfLoading, reportName }) => (
  <>
    <Button variant="primary" onClick={(e) => onCSVExport(e.target.value)} style={{fontSize: "14px"}}>
     CSV
    </Button>
    <Button variant="primary" onClick={(e) => onPDFExport(e.target.value)} style={{fontSize: "14px"}} disabled={pdfLoading || !reportName}>
      PDF
    </Button>{" "}
    <Button variant="primary" onClick={(e) => onXLSXExport(e.target.value)} style={{fontSize: "14px"}}>
      XLSX
    </Button>
  </>
);

const sortReportParams = (queryParams) => {
  let parameters = [
    {
      paramName: "p_departmentId",
      paramValue: queryParams.p_departmentId,
      paramDataType: "java.lang.Integer"
    },
    {
      paramName: "p_provinceId",
      paramValue: queryParams.p_provinceId,
      paramDataType: "java.lang.Integer"
    },
    {
      paramName: "p_provAgencyId",
      paramValue: queryParams.p_provAgencyId,
      paramDataType: "java.lang.Integer"
    },
    {
      paramName: "p_serviceTypeId",
      paramValue: queryParams.p_serviceType,
      paramDataType: "java.lang.Integer"
    },
    {
      paramName: "p_serviceItemId",
      paramValue: queryParams.p_serviceItem,
      paramDataType: "java.lang.Integer"
    },
    {
      paramName: "p_fromDate",
      paramValue: queryParams.p_fromDate,
      paramDataType: "java.sql.Date"
    },
    {
      paramName: "p_toDate",
      paramValue: queryParams.p_toDate,
      paramDataType: "java.sql.Date"
    },
    {
      paramName: "p_timeInterval",
      paramValue: queryParams.p_timeInterval,
      paramDataType: "java.lang.String"
    }
  ];

  parameters = parameters.filter((param) => param.paramValue !== "" && param.paramValue !== null && param.paramValue !== undefined );
  
  return parameters;
};

const dataTableStyles = {
  rows: {
    style: {
      fontSize: "16px"
    },
  },
  headCells: {
    style: {
      fontSize: "16px"
    },
  },
  cells: {
    style: {
      fontSize: "16px"
    },
  },
  pagination: {
    style: {
      fontSize: "16px"
    }
  }
};

export function ReportsTable() {
  const dispatch = useDispatch();

  const { receiptTracking, auth, reports } = useSelector((state) => state);
  
  const { masterReceipts:data } = receiptTracking;
  const { listLoading, receiptsMaxLimit, receiptMaxErrorMsg } = receiptTracking;
  const { user } = auth;
  const { reportDataString, fetchingReportStr } = reports;

  const provAgencyId = user.prov_agency_id;
  
  const [reportTitle, setReportTitle] = useState("");
  const [ showRcptLimitErr, setShowRcptLimitErr ] = useState(false);
  const [ filteredData, setFilteredData ] = useState([]);
  const [ resetPagination, setResetPagination ] = useState(false);

  const columns = [
    {
      name: "Receipt No.",
      selector: (row) => row.rcpt_number,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.rcpt_status_desc,
      sortable: true
    },
    {
      name: "Customer",
      selector: (row) => row.cust_first_name + " " + row.cust_last_name,
      sortable: true
    },
    {
      name: "Service Type",
      selector: (row) => row.service_name,
      sortable: true
    },
    {
      name: "Service Item",
      selector: (row) => row.service_desc,
      sortable: true,
    },
    {
      name: "Mobile",
      selector: (row) => row.cust_msisdn,
      sortable: true
    },
    {
      name: "Department",
      selector: (row) => row.dept_name,
      sortable: true
    },
    {
      name: "Province",
      selector: (row) => row.province_name,
      sortable: true
    },
    {
      name: "Amount",
      selector: (row) => moneyFormater.format(row.total_amnt),
      sortable: true
    },
    {
      name: "Date Issued",
      selector: (row) => row.rcpt_issued_date,
      sortable: true
    }
  ];

  const actionsMemo = useMemo(
    () => (
      <Export
        onPDFExport={() => downloadPDFReport(reportDataString, reportTitle)}
        onCSVExport={() => downloadCSV(filteredData, reportTitle)}
        onXLSXExport={() => downloadEXCEL(filteredData, reportTitle)}
        pdfLoading={fetchingReportStr}
        reportName={reportTitle}
      />
    ),
    [filteredData, reportTitle, reportDataString, fetchingReportStr]
  );

  useEffect(() => {
    let filteredRcpt = data;
    
    if (reportTitle === "Revenue Collections"){

      filteredRcpt = data.filter((rcpt) => ( rcpt.rcpt_status_desc === "Issued" || rcpt.rcpt_status_desc === "Used" ));
      
    } else if (reportTitle === "Services Rendered"){

      filteredRcpt = data.filter((rcpt) => ( rcpt.rcpt_status_desc === "Used"));
    } else if (reportTitle === "Transactions"){

      filteredRcpt = data.filter((rcpt) => ( rcpt.rcpt_status_desc === "Issued" || rcpt.rcpt_status_desc === "Used" || rcpt.rcpt_status_desc === "Refund Completed"));
    } else if (reportTitle === "Receipts Collected"){

      filteredRcpt = data;
    }
    
    setFilteredData(filteredRcpt);
  }, [data, reportTitle]);
  
  useEffect(() => {
    dispatch(rtSagaActions.fetchMasterReceipts(provAgencyId, {
      fromIssuedDate: formatPresentDate,
      toIssuedDate: formatPresentDate
    }));
  }, [dispatch, provAgencyId]);

  useEffect(() => {
    if(receiptsMaxLimit){
      setShowRcptLimitErr(true);
      setTimeout(() => {
        dispatch(rtReducerActions.clearReceiptMaxLimit());
        setShowRcptLimitErr(false);
      }, 8000);
    } else {
      setShowRcptLimitErr(false);
    }
  }, [receiptsMaxLimit, dispatch, receiptMaxErrorMsg]);

  const closeAlert = () => {
    dispatch(rtReducerActions.clearReceiptMaxLimit());
    setShowRcptLimitErr(false);
  };

  const handleSearchReportReceipts = (queryParams) => {
    setReportTitle(queryParams.p_reportType);
    setResetPagination(true);
    handleReceiptsSearch(queryParams);
    handleReportSearch(queryParams);
  };

  const handleReceiptsSearch = (queryParams) => {
    
    let adjustedQueryParams = { 
      fromIssuedDate: queryParams.p_fromDate, 
      toIssuedDate: queryParams.p_toDate,
      departmentId: queryParams.p_departmentId, 
      serviceId: queryParams.p_serviceType,
      serviceItemId: queryParams.p_serviceItem,
      provinceId: queryParams.p_provinceId,
      provAgencyId: queryParams.p_provAgencyId
    };
    
    dispatch(rtSagaActions.fetchMasterReceipts(provAgencyId, adjustedQueryParams));
    setResetPagination(false);
  };

  const handleReportSearch = (queryParams) => {
    handleGeneratePDFReport(queryParams);
  };

  const handleGeneratePDFReport = (queryParams) => {
    let definedParams = sortReportParams(queryParams);

    let reportQueryParams = {
      reportFileNameWithExt: queryParams.p_reportType === "Receipts Collected" ? "agency-receipt-collections-report.jrxml" 
        : ( queryParams.p_reportType === "Revenue Collections" ? "agency-revenue-collections-report.jrxml" 
        : (queryParams.p_reportType === "Services Rendered" ? "agency-services-rendered-report.jrxml" 
        : (queryParams.p_reportType === "Transactions" && "agency-transactions-report.jrxml"))),
      parameters: definedParams,
      generatedFileName: `${queryParams.p_reportType} Report ${dateStr}`,
      reportOutputTypeCode: "PDF",
      saveFile: false
    };
    
    dispatch(reportSagaActions.findReports(reportQueryParams));
  };


  return (
    <div className="card card-custom card-stretch gutter-b text-14">
      {/* begin::Header */}

      {/* end::Header */}

      {/* begin::Body */}

      {
        showRcptLimitErr ?
        <div className="d-flex justify-content-end">
          <Alert variant="info" transition={Fade} onClose={closeAlert} dismissible style={{ width: "50%", zIndex: 2, position: "absolute" }} >
            <Alert.Heading > Maximum Receipt Records Reached </Alert.Heading>
            <p>
              <b> {receiptMaxErrorMsg} </b>
              <br/>
              Adjust your search parameters to make a narrow or specific search for receipt records.
            </p>
          </Alert>
        </div>
        : null  
      }

      <div className="card-body py-6">
        <div className="row justify-content-start">
          <div className="col-12">
            <ReportSearchForm
              onHandleSearchReport={handleSearchReportReceipts}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            {/* begin::Table */}
            <DataTable
              title={<h4>{reportTitle}</h4>}
              customStyles={dataTableStyles}
              columns={columns}
              data={filteredData}
              actions={actionsMemo}
              progressPending={listLoading}
              progressComponent={<Spinner animation="border" />}
              pagination
              paginationResetDefaultPage={resetPagination}
              highlightOnHover
            />
            {/* end::Table */}
          </div>
        </div>
        {/*<h2>Total expenses this week: {totalAmount}</h2>*/}
      </div>
      {/* end::Body */}
    </div>
  );
}
